// extracted by mini-css-extract-plugin
export default {"withdrawalApplySuccess":"withdrawalApplySuccess-gkV2q","successful":"successful-ZFwlW","title":"title-su_O2","amount":"amount-hudMy"};